import { render } from "./cloudPosPre.vue?vue&type=template&id=4f9b947f"
import script from "./cloudPosPre.vue?vue&type=script&lang=js"
export * from "./cloudPosPre.vue?vue&type=script&lang=js"

import "./cloudPosPre.vue?vue&type=style&index=0&id=4f9b947f&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__